import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';

/**
 * Generate a filled DOCX file from a template
 * @param {Object} data - The combined data object
 */
export const generateDocx = async (data) => {
    try {
        // Load the template
        // Assumes the template is in the public folder
        const response = await fetch('/Simptww_Template.docx');

        if (!response.ok) {
            throw new Error(`Template not found at /Simptww_Template.docx (${response.status})`);
        }

        const content = await response.arrayBuffer();

        const zip = new PizZip(content);
        let doc;
        try {
            doc = new Docxtemplater(zip, {
                paragraphLoop: true,
                linebreaks: true,
            });
        } catch (error) {
            // Catch compilation errors (e.g. malformed tags)
            if (error.properties && error.properties.errors) {
                const errorMessages = error.properties.errors.map(e => e.properties.explanation).join('\n');
                console.error('Template Compilation Errors:', errorMessages);
                throw new Error(`Template Fout: ${errorMessages}`);
            }
            throw error;
        }

        // Prepare data for the template
        const templateData = {
            // General Info
            ultimoNr: data.ultimoNr || '',
            date: data.date || new Date().toLocaleDateString('nl-NL'),
            description: data.description || '',
            goal: data.goal || '',

            // Location & Task
            hall: data.hall || '',
            line: data.line || '',
            subline: data.subline || '',
            component: data.component || '',
            task: data.task || '',
            discipline: data.discipline || '',

            // Personnel
            werkvoorbereider: data.werkvoorbereider || '',
            werkverantwoordelijke: data.werkverantwoordelijke || '',
            monteur1: data.monteur1 || '',
            monteur2: data.monteur2 || '',

            // Boolean flags
            lotoRequired: data.lotoRequired,
            hasPermits: data.permits && data.permits.length > 0,

            // Lists for loops {#list}...{/list}
            risks: data.risks || [],
            pbms: data.pbms || [],
            tools: data.tools || [],
            steps: data.steps || [],
            lotoSteps: data.lotoSteps || [],
            permits: data.permits ? data.permits.map(p => ({ name: p })) : [],

            // Computed strings
            permitsString: data.permits ? data.permits.join(', ') : 'Geen',

            // New Data Fields
            qualification: data.qualification || 'Geen',

            // Hazards (Booleans for checkboxes in Word if supported, or strings)
            hazardElectrical: data.hazards?.electrical ? 'JA' : 'Nee',
            hazardPressure: data.hazards?.pressure ? 'JA' : 'Nee',
            hazardMovement: data.hazards?.movement ? 'JA' : 'Nee',
            hazardHeat: data.hazards?.heat ? 'JA' : 'Nee',
            hazardChemicals: data.hazards?.chemicals ? 'JA' : 'Nee',

            // Specific LOTOTO List
            specificLoto: data.specificLoto || [],
            hasSpecificLoto: data.specificLoto && data.specificLoto.length > 0,

            // Hygiene
            hygieneCategories: data.hygieneCategories ? data.hygieneCategories.map(c => ({ category: c })) : [],
            hasHygiene: data.hygieneCategories && data.hygieneCategories.length > 0,

            // Lifting Plan
            liftingPlanType: data.liftingPlanType || null,
            isRoutineLifting: data.liftingPlanType === 'routine',
            isComplexLifting: data.liftingPlanType === 'complex',
        };

        // Render the document
        try {
            doc.render(templateData);
        } catch (error) {
            // Catch rendering errors (e.g. missing data for tags)
            if (error.properties && error.properties.errors) {
                const errorMessages = error.properties.errors.map(e => e.properties.explanation).join('\n');
                console.error('Template Render Errors:', errorMessages);
                throw new Error(`Template Render Fout: ${errorMessages}`);
            }
            throw error;
        }

        // Generate blob
        const out = doc.getZip().generate({
            type: 'blob',
            mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        });

        // Save file
        const filename = `SIMPTWW_${data.ultimoNr || 'Concept'}_${new Date().toISOString().split('T')[0]}.docx`;
        saveAs(out, filename);

    } catch (error) {
        console.error('Error generating DOCX:', error);
        alert(`Fout bij genereren document: ${error.message}\n\nZorg ervoor dat 'Simptww_Template.docx' in de public map staat.`);
    }
};
